package com.mps.asc_app.util

data class TodayDate(
    val day: Int,
    val month: Int,
    val year: Int
)
